import type { Level, MusicCue, SpawnContext, TimelineEvent } from "./levelTypes.ts";

/** Small fluent builder for authoring level timelines without noise. */
export class LevelBuilder {
  private events: TimelineEvent[] = [];
  private music: MusicCue[] = [];

  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly archetype: string,
    private readonly duration: number,
  ) {}

  /** Schedule a single spawn at time `t`. */
  at(t: number, fire: (ctx: SpawnContext) => void): this {
    this.events.push({ t, fire });
    return this;
  }

  /** Schedule `fire` repeatedly from `start` to `end` every `every` seconds. */
  every(start: number, end: number, every: number, fire: (ctx: SpawnContext, t: number) => void): this {
    for (let t = start; t <= end + 1e-6; t += every) {
      const time = t;
      this.events.push({ t: time, fire: (ctx) => fire(ctx, time) });
    }
    return this;
  }

  cue(t: number, cue: string): this {
    this.music.push({ t, cue });
    return this;
  }

  build(): Level {
    return {
      id: this.id,
      name: this.name,
      archetype: this.archetype,
      duration: this.duration,
      events: this.events,
      music: this.music,
    };
  }
}
